const FileUsagesEnum = Object.assign({
  MAIL: 'mail',
  COCKPIT: 'cockpit',
  CONTRACT: 'contract',
  DEPOT: 'depot',
  NONE: 'none',
});

Object.freeze(FileUsagesEnum);

export default FileUsagesEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/FileUsages.js